import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Hero } from '../components/home/Hero';
import { RoofTypes } from '../components/home/RoofTypes';
import { ExpertServices } from '../components/home/ExpertServices';
import { TrustBadges, CompanyTrust } from '../components/home/TrustSections';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { Testimonials } from '../components/home/GalleryTestimonials';
import { Brands } from '../components/home/FaqBrands';
import { ScheduleCta } from '../components/home/CtaPostsCoupons';
import { MAIN_SERVICES, SERVICE_PAGES } from '../data/site';

// Renders both main service pages (/gutters, /siding, /chimney-repair) and sub-service pages (/services/:slug)
export default function ServicePage({ mainSlug }) {
  const params = useParams();
  const slug = mainSlug || params.slug;
  const data = mainSlug ? MAIN_SERVICES[mainSlug] : SERVICE_PAGES[slug];

  useEffect(() => {
    if (data) document.title = `${data.title} - Phoenix Roofing & Chimney NJ`;
  }, [data]);

  if (!data) return <Navigate to="/" replace />;

  return (
    <div data-testid={`service-page-${slug}`}>
      <Hero kicker="Top Rated Roofing Company" titleWhite="Phoenix" titleRed={data.title} sub="Free Inspections" />
      <section className="py-20 bg-background">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="section-title" data-testid="service-sub-title">{data.sub}</h2>
          <p className="mt-6 text-lg text-foreground/85">{data.desc}</p>
        </div>
      </section>
      <RoofTypes />
      <ExpertServices />
      <TrustBadges />
      <CompanyTrust />
      <ServicesGrid />
      <Testimonials />
      <Brands />
      <ScheduleCta />
    </div>
  );
}
